import { createContext, useState, useReducer } from 'react';
import './App.css';
import Home from './components/Home/Home/Home';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Help from './components/Help/Help';
import SignUp from './components/LoginManager/SignUp/SignUp';
import Login from './components/LoginManager/Login.js/Login';
import TermsAndService from './components/Privacy/TremsAndService/TermsAndService';
import Checkout from './components/shared/Cart/Checkout/Checkout';
import PrivetRoute from './components/LoginManager/PrivetRoute/PrivetRoute';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import firebase from "firebase/app";
import "firebase/auth";
import Orders from './components/Orders/Orders';
import 'rsuite/dist/styles/rsuite-default.css'
import OrdersDetail from './components/OrderDetail/OrdersDetail';
import Offer from './components/Offer/Offer';

const initialState = {
  cart: [],
  user: null,
  totalAmount: 0,
  totalItem: 0
}

const reducer = (state, action) => {
  switch (action.type) {


    case 'EMPTY_CARD':
      return { ...state, cart: action.cart }

    case 'REMOVE_ITEM':
      return { ...state, cart: action.product }
    case 'ADD_CARD':

      const added = state.cart.find(item => item.id === action.product.id)
      let remaining;
      let newCart;
      if (added) {
        remaining = state.cart.filter(item => item.id !== action.product)
      } else {
        newCart = [...state.cart, action.product]
      }
      return { ...state, cart: remaining || newCart }

    case 'INCREMENT':
      const updateCart = state.cart.map((curElem) => {

        if (curElem.id === action.id) {
          return {
            ...curElem,
            quantity: curElem.quantity + 1,
          }
        }
        return curElem;
      })

      return { ...state, cart: updateCart }

    case 'DECREMENT':
      const updatedCart = state.cart
        .map((curElem) => {
          if (curElem.id === action.id) {
            return { ...curElem, quantity: curElem.quantity - 1 };
          }
          return curElem;
        })
        .filter((curElem) => curElem.quantity !== 0);

      return { ...state, cart: updatedCart };


    case (action.type === "GET_TOTAL"):

      let { totalAmount, totalItem } = state.cart.reduce((accum, curVal) => {
        let { price, quantity } = curVal;
        let updatedTotalAmount = price * quantity;
        accum.totalAmount = totalAmount + updatedTotalAmount;

        accum.totalItem = totalItem + quantity;
        return accum;
      },
        {
          totalAmount: 0,
          totalItem: 0
        }
      );
      return { ...state, totalItem: totalItem, totalAmount: totalAmount };



    default:
      return state;
  }
}


export const ApplicationProvider = createContext()

function App() {
  const [globalState, globalDispatch] = useReducer(reducer, initialState)
  const [user, setUser] = useState(null)

  console.log(globalState);
  useEffect(() => {
    firebase.auth().onAuthStateChanged((isUser) => {
      if (isUser) {
        setUser(isUser)

      }
      globalDispatch({ type: 'GET_TOTAL' })
      console.log('aa');
    });

  }, [globalState.cart])


  return (
    <ApplicationProvider.Provider value={[globalState, globalDispatch, user, setUser]}>
      <Router>
        <Toaster />
        <Switch>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route path='/home'>
            <Home />
          </Route>
          <Route path='/help'>
            <Help />
          </Route>
          <Route path='/signup'>
            <SignUp />
          </Route>
          <Route path='/login'>
            <Login />
          </Route>
          <Route path='/terms'>
            <TermsAndService />
          </Route>
          <Route path='/privacy'>
            <TermsAndService />
          </Route>
          <PrivetRoute path='/checkout'>
            <Checkout />
          </PrivetRoute>
          <PrivetRoute path='/orders'>
            <Orders />
          </PrivetRoute>
          <PrivetRoute path='/ordersDetail/:id'>
            <OrdersDetail />
          </PrivetRoute>
          <Route path='/offer'>
            <Offer />
          </Route>
        </Switch>
      </Router>
    </ApplicationProvider.Provider>
  );
}

export default App;
